export default __webpack_public_path__ + "static/media/keyvis_players_left_dt@2x.c0d97b37.png";